<div class="container conteudo mt-4" [formGroup]="form">
  <div  class="cabecalho">
    <p class="cabecalho__contexto">Instituto Previdenciário</p>
    <h1 class="titulo">Solicitação de Resgate</h1>
  </div>

  <!-- Dados bancários -->
  <vivest-card class="secao" variant="elevated" full-width>
    <section class="secao__conteudo" aria-labelledby="titulo-dados-bancarios">
      <div class="secao__cabecalho">
        <h5 id="titulo-dados-bancarios">Insira seus dados bancários</h5>
        <p class="secao__descricao">Indique onde devemos depositar os valores do resgate</p>
      </div>

      <div class="campos">
        <vivest-autocomplete
          class="campo campo--busca"
          label="Banco"
          name="banco"
          icon="search"
          placeholder=""
          [options]="bancos()"
          formControlName="banco"
        ></vivest-autocomplete>
        <vivest-input
          class="campo"
          label="Agência"
          name="agencia"
          vivestFormat="digits"
          [vivestMaxLength]="5"
          icon=""
          placeholder=""
          type="text"
          formControlName="agencia"
        ></vivest-input>
        <vivest-input
          class="campo"
          label="Conta"
          name="conta"
          vivestFormat="conta"
          [vivestMaxLength]="15"
          icon=""
          placeholder=""
          type="text"
          formControlName="conta"
        ></vivest-input>
      </div>
    </section>
  </vivest-card>

  <!-- Regime de tributação e parcelas -->
  <vivest-card class="secao secao--tributacao" variant="elevated" full-width>
    <div class="secao__conteudo secao__conteudo--tributacao">
      <section class="tributacao" aria-labelledby="titulo-tributacao">
        <div class="secao__cabecalho">
          <h4 id="titulo-tributacao" class="secao__titulo">Regime de Tributação</h4>
          <p class="secao__descricao">Escolha qual o modelo de tributação para o Imposto de Renda</p>
        </div>

        <div class="regimes" role="radiogroup" aria-labelledby="titulo-tributacao">
          @for (opcao of regimes; track opcao.id) {
            <div
              class="regime"
              [class.regime--selecionado]="regime() === opcao.id"
              (click)="selecionarRegime(opcao.id)"
            >
              <vivest-radio
                label-variant="single-line"
                name="regime-tributacao"
                [value]="opcao.id"
                [checked]="regime() === opcao.id"
                (change)="onRegimeChange($event, opcao.id)"
              >
                {{ opcao.titulo }}
              </vivest-radio>
            </div>
          }
        </div>
      </section>

      <section class="parcelas">
        <h2 id="titulo-parcelas" class="parcelas__titulo">
          Em quantas parcelas deseja receber seu resgate?
        </h2>
        <vivest-select
          class="parcelas__select"
          name="parcelas"
          label=""
          aria-label="Quantidade de parcelas"
          placeholder="Selecione"
          [options]="parcelas"
          formControlName="parcelas"
        ></vivest-select>
      </section>
    </div>
  </vivest-card>

  <!-- Residência no exterior -->
  <vivest-card class="secao" variant="elevated" full-width>
    <section class="secao__conteudo secao__conteudo--exterior" aria-labelledby="titulo-exterior">
      <div class="exterior" role="radiogroup" aria-labelledby="titulo-exterior">
        <h2 id="titulo-exterior" class="exterior__pergunta">Você reside no exterior?</h2>
        <div class="exterior__opcoes">
          <vivest-radio
            label-variant="multi-line"
            name="reside-exterior"
            value="sim"
            [checked]="resideExterior() === true"
            (change)="onResideExteriorChange($event, true)"
          >
            Sim
          </vivest-radio>
          <vivest-radio
            label-variant="multi-line"
            name="reside-exterior"
            value="nao"
            [checked]="resideExterior() === false"
            (change)="onResideExteriorChange($event, false)"
          >
            Não
          </vivest-radio>
        </div>
        </div>

      @if (resideExterior()) {
        <div class="campos">
          <vivest-autocomplete
            class="campo campo--busca"
            label="País"
            name="pais"
            icon="search"
            placeholder=""
            [options]="paises()"
            formControlName="pais"
          ></vivest-autocomplete>
          <vivest-input
            class="campo"
            vivestFormat="digits"
            label="ZIP Code"
            name="zipCode"
            [vivestMaxLength]="15"
            icon=""
            placeholder=""
            type="text"
            formControlName="zipCode"
          ></vivest-input>
          <vivest-input
            class="campo"
            vivestFormat="digits"
            label="NIF"
            name="nif"
            [vivestMaxLength]="30"
            icon=""
            placeholder=""
            type="text"
            formControlName="nif"
          ></vivest-input>
        </div>
      }
    </section>
  </vivest-card>
</div>

<div class="d-flex justify-content-center align-items-center buttons top-64">
  <vivest-button variant="outline" size="md" (click)="onReturn()">
    Voltar
  </vivest-button>
  <vivest-button variant="primary" size="md" [disabled]="!podeContinuar()" (click)="onSubmit()">
    <vivest-icon slot="icon-right" name="arrow-right" source="feather"></vivest-icon>
    Continuar para assinatura
  </vivest-button>
</div>
